import { db } from "../dexie";
import { Habit, HabitRecord, habitRecordSchema, nullableUuid } from "../types";
import { Collection } from "../utils/collection";

export const Habits = {
  getAll() {
    return new Collection<Habit, HabitRecord>(habitRecordSchema, db.habits.orderBy("order"));
  },
  getByParentId(parentId: string | null) {
    const dbParentId = nullableUuid.decode(parentId);
    return new Collection<Habit, HabitRecord>(
      habitRecordSchema,
      db.habits.where({ parentId: dbParentId }),
    );
  },
};
